import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react'
import { useState } from 'react'

export default function CardsVerticais({ initialSections }) {
  // Define os conteúdos com base nos inicialmente fornecidos
  const [sections, setSections] = useState(
    initialSections || [
      {
        title: 'Título Superior',
        content: 'Conteúdo do card superior.',
      },
      {
        title: 'Título Central',
        content: 'Conteúdo do card central em destaque.',
      },
      {
        title: 'Título Inferior',
        content: 'Conteúdo do card inferior.',
      },
    ],
  )

  // Acompanha o índice ativo atual (inicialmente 1, o do meio)
  const [activeIndex, setActiveIndex] = useState(1)

  // Função para mover o conteúdo quando a div superior for clicada
  const handleTopClick = () => {
    setSections(prevSections => [
      prevSections[1], // O conteúdo do meio vai para cima
      prevSections[0], // O conteúdo de cima vai para o meio
      prevSections[2], // O conteúdo de baixo permanece igual
    ])
    setActiveIndex(0) // Atualiza o índice ativo para o primeiro item
  }

  // Função para mover o conteúdo quando a div inferior for clicada
  const handleBottomClick = () => {
    setSections(prevSections => [
      prevSections[0], // O conteúdo de cima permanece igual
      prevSections[2], // O conteúdo de baixo vai para o meio
      prevSections[1], // O conteúdo do meio vai para baixo
    ])
    setActiveIndex(2) // Atualiza o índice ativo para o último item
  }

  // Função para rotacionar para a esquerda
  const handleLeftClick = () => {
    setSections(prevSections => [
      prevSections[1], // O meio vai para cima
      prevSections[2], // O último vai para o meio
      prevSections[0], // O primeiro vai para o final
    ])
    // Atualiza o índice ativo
    setActiveIndex(prev => (prev === 0 ? 2 : prev - 1))
  }

  // Função para rotacionar para a direita
  const handleRightClick = () => {
    setSections(prevSections => [
      prevSections[2], // O último vai para cima
      prevSections[0], // O primeiro vai para o meio
      prevSections[1], // O meio vai para o final
    ])
    // Atualiza o índice ativo
    setActiveIndex(prev => (prev === 2 ? 0 : prev + 1))
  }

  // Função para lidar com o clique nos dots
  const handleDotClick = index => {
    if (index === activeIndex) return // Não faz nada se já estiver ativo

    if (index === 0) {
      setSections([
        sections[1], // O meio vai para cima
        sections[0], // O topo vai para o meio
        sections[2], // O último permanece igual
      ])
    } else if (index === 2) {
      setSections([
        sections[0], // O topo permanece igual
        sections[2], // O último vai para o meio
        sections[1], // O meio vai para o fim
      ])
    }

    setActiveIndex(index)
  }

  return (
    <>
      <div className="shadow-xl hidden md:block">
        <div
          className="rounded-t-[10px] py-5 px-10 backdrop-blur-md bg-white/20 mx-8 cursor-pointer hover:bg-white/10 transition-colors duration-300"
          onClick={handleTopClick}
        >
          <p className="text-[#191187] uppercase">{sections[0].title}</p>
        </div>
        <div className="ring ring-white rounded-[10px] py-14 px-10 backdrop-blur-md bg-white/20 space-y-4 relative z-10 shadow-md h-[252px]">
          <h3 className="text-lg font-inter-bold uppercase">
            {sections[1].title}:
          </h3>
          <p>{sections[1].content}</p>
        </div>
        <div
          className="rounded-b-[10px] py-5 px-10 backdrop-blur-md bg-white/20 mx-8 cursor-pointer hover:bg-white/10 transition-colors duration-300"
          onClick={handleBottomClick}
        >
          <p className="text-[#191187] uppercase">{sections[2].title}</p>
        </div>
      </div>

      <div className="shadow-xl md:hidden">
        <section className="flex">
          <div className="ring z-20 ring-white rounded-[10px] max-w-72 py-16 px-10 backdrop-blur-md bg-white/20 space-y-4 relative shadow-md">
            <h3 className="text-lg font-inter-bold uppercase">
              {sections[0].title}:
            </h3>
            <p>{sections[0].content}</p>
          </div>
          <div
            className="flex z-10 mx-3 relative justify-end pb-14 writing-mode-vertical-rl rounded-tl-[10px] rounded-bl-[10px] -ml-1.5 rotate-180 py-3 backdrop-blur-md ring-1 ring-white bg-white/20 cursor-pointer hover:bg-white/10 transition-colors duration-300"
            style={{ writingMode: 'vertical-rl' }}
            onClick={handleTopClick}
          >
            <p className="text-[#191187] uppercase text-xs">
              {sections[1].title}
            </p>
          </div>
          <div
            className="flex z-0 mx-6 relative justify-end pb-14 writing-mode-vertical-rl rounded-tl-[10px] rounded-bl-[10px] -ml-1.5 rotate-180 py-3 backdrop-blur-md ring-1 ring-white bg-white/20 cursor-pointer hover:bg-white/10 transition-colors duration-300"
            style={{ writingMode: 'vertical-rl' }}
            onClick={handleTopClick}
          >
            <p className="text-[#191187] uppercase text-xs">
              {sections[2].title}
            </p>
          </div>
        </section>

        <div className="mt-8 flex justify-center items-center gap-2.5">
          <button type="button" onClick={handleLeftClick}>
            <ChevronLeftIcon className="size-10" />
          </button>

          {/* Carousel indicators */}
          <div className="flex flex-row gap-3 items-center">
            {sections.map((_, i) => (
              <div
                key={i}
                onClick={() => handleDotClick(i)}
                className={`h-[6px] rounded-full cursor-pointer transition-all duration-300 ${
                  i === activeIndex
                    ? 'bg-transparent border border-white'
                    : 'bg-white'
                } ${i === 0 ? 'w-[23px]' : i === 1 ? 'w-[15px]' : 'w-[6px]'}`}
              />
            ))}
          </div>

          <button type="button" onClick={handleRightClick}>
            <ChevronRightIcon className="size-10" />
          </button>
        </div>
      </div>
    </>
  )
}
